import { type FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import {
  type SalaryTypes,
  type A3Config
} from 'src/modules/Settings/Integrations/pages/components/integrations2.0/A3/utils';
import { type IntegrationParamOption } from './common';
import { zeusApiV1 } from 'src/store/api';

type GetIntegrationArgs = {
  subsidiary: string;
  companyCode: string;
};

export type CompanyParams = {
  salaryTypes: SalaryTypes[];
  customFields: IntegrationParamOption[];
};

const extendedApi = zeusApiV1.injectEndpoints({
  endpoints: build => ({
    getIntegrationUrl: build.query<string, GetIntegrationArgs>({
      queryFn: async ({ subsidiary, companyCode }, _api, _extraOptions, baseQuery) => {
        try {
          const result = await baseQuery({
            url: '/hercules/v1/a3/oauth',
            params: {
              subsidiary,
              companyCode
            }
          });

          if (result.error) {
            return { error: result.error };
          }

          const url = (result.data as { url: string }).url;

          setTimeout(() => {
            globalThis.location.replace(url);
          }, 1500);

          return { data: url };
        } catch (error) {
          console.error('Error fetching integration URL:', error);

          return { error: error as FetchBaseQueryError };
        }
      }
    }),
    getCompanyParams: build.query<CompanyParams, GetIntegrationArgs>({
      query: ({ subsidiary, companyCode }) => ({
        url: '/hercules/v1/a3/company-params',
        params: {
          subsidiary,
          companyCode
        }
      })
    }),
    saveA3: build.mutation<A3Config, Partial<A3Config>>({
      query: args => ({
        url: '/hercules/v1/a3/config',
        method: 'PATCH',
        body: args
      }),
      invalidatesTags: ['integration']
    })
  }),
  overrideExisting: false
});

export const { useGetIntegrationUrlQuery, useLazyGetIntegrationUrlQuery, useGetCompanyParamsQuery, useSaveA3Mutation } =
  extendedApi;
